import React from 'react';
import { Stack, Typography, Button, IconButton, Box } from '@mui/material';
import { Upload, Delete } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import { useTheme } from '@mui/material/styles';

function FileUploadSection({ 
    fileType,
    files, 
    onFilesChange, 
    onPendingFileChange, 
    onFileSubmit, 
    isLoading
}) {
    const theme = useTheme();
    const handleFileChange = (e) => {
        const fileList = e.target.files;
        onFilesChange(fileList);
    };

    const handleClearFiles = () => {
        onFilesChange([]);
        onPendingFileChange(null);
    };

    return (
        <Box sx={{ 
            border: '1px solid', 
            borderColor: theme.palette.border.main, 
            borderRadius: 1, 
            p: 2, 
            backgroundColor: theme.palette.background.main,
            flex: 1,
            display: 'flex',
            flexDirection: 'column'
        }}>
            <Typography variant='heavy' fontSize='16px' sx={{ mb: 2 }}>
                Upload {fileType} File
            </Typography>
            <Stack spacing={1}>
                { files.length > 0 ? 
                    <Stack direction='row' spacing={1} alignItems='center'>
                        <Typography variant='normal' fontSize='16px'>{files[0].name}</Typography>
                        <IconButton onClick={handleClearFiles}>
                            <Delete />
                        </IconButton>
                    </Stack> :
                    <Typography variant='normal' fontSize='16px' sx={{ color: theme.palette.subtext.main }}>
                        No file selected
                    </Typography>
                }
                <Button variant='outlined' disabled={files.length > 0} component='label' startIcon={<Upload />} color='primary' style={{ alignSelf: 'start' }}>
                    Upload {fileType} File
                    <input hidden accept='text/csv' type='file' onChange={handleFileChange} />
                </Button>
                <LoadingButton
                    loading={isLoading}
                    variant='contained'
                    color='primary'
                    style={{ alignSelf: 'start' }}
                    disabled={files.length === 0}
                    onClick={onFileSubmit}
                >
                    Submit {fileType} File
                </LoadingButton>
            </Stack>
        </Box>
    );
}

export default FileUploadSection;